import { createAction } from 'redux-actions';
import types            from './types';

const startFetch = createAction(types.START_FETCH);
const endFetch = createAction(types.END_FETCH);
const endError = createAction(types.END_ERROR);
const updateProfile = createAction(types.UPDATE_PROFILE);
const updateUser = createAction(types.UPDATE_USER);
const changeLanguage = createAction(types.CHANGE_LANGUAGE);
const changePassword = createAction(types.CHANGE_PASSWORD);
const clear = createAction(types.CLEAR);
const logout = createAction(types.LOGOUT);
const login = createAction(types.LOGIN);
const signIn = createAction(types.SIGN_IN);
const updateExpToken = createAction(types.UPDATE_TOKEN_EXP);
const downloadQr = createAction(types.DOWNLOAD_QR);

const showMessage = createAction(types.MESSAGE,
  ({ message }) => ({
    message,
  }),
  ({ config }) => ({
    config,
  }));

export default {
  startFetch,
  endFetch,
  endError,
  updateProfile,
  changeLanguage,
  signIn,
  showMessage,
  changePassword,
  clear,
  logout,
  login,
  updateUser,
  updateExpToken,
  downloadQr,
};
